import React from "react";
import { Check } from "@phosphor-icons/react";
import { BOOKABLE_CONSULTANTS } from "../../data/consultants";

const OPTIONS = [
  ...BOOKABLE_CONSULTANTS.map((c) => ({ slug: c.slug, name: c.name, sub: c.title, image: c.image })),
  { slug: "any", name: "First available consultant", sub: "We’ll match you with the right consultant for your needs" },
];
const TESTS_OPTION = { slug: "tests", name: "Tests only - no consultation", sub: "An echo or 24-hour blood pressure monitoring on its own", initials: "Tests" };

const Option = ({ o, on, pick }) => (
  <button type="button" onClick={() => pick(o.slug)} data-testid={`consultant-option-${o.slug}`} aria-pressed={on}
    className={`relative text-left flex items-center gap-4 p-4 rounded-md border transition-colors ${on ? "border-bronze-dark bg-cream-100 ring-1 ring-bronze-dark" : "border-stone-200 hover:border-bronze-light bg-white"}`}>
    {o.image
      ? <img src={o.image} alt="" className="h-14 w-14 rounded-full object-cover object-top shrink-0" />
      : <span className="h-14 w-14 rounded-full bg-cream-100 border border-bronze-light/50 shrink-0 flex items-center justify-center font-serif text-bronze-dark text-sm">{o.initials || "Any"}</span>}
    <span className="min-w-0">
      <span className="block font-medium text-ink">{o.name}</span>
      <span className="block text-xs text-ink-muted mt-0.5 leading-snug">{o.sub}</span>
    </span>
    {on && <span className="absolute top-2 right-2 h-5 w-5 rounded-full bg-bronze-dark text-white flex items-center justify-center"><Check size={12} weight="bold" /></span>}
  </button>
);

export const ConsultantPicker = ({ value, onChange, step = 1, testsOption = false }) => (
  <fieldset data-testid="consultant-picker" className="bg-white border border-bronze-light/30 rounded-md p-6">
    <legend className="sr-only">Choose your consultant</legend>
    <div className="eyebrow">Step {step}</div>
    <h2 className="font-serif text-2xl mt-1">Who would you like to see?</h2>
    <p className="text-sm text-ink-muted mt-1">Please choose a consultant - or pick &ldquo;First available&rdquo; and we&apos;ll match you.</p>
    <div className="mt-5 grid sm:grid-cols-2 gap-3">
      {(testsOption ? [...OPTIONS, TESTS_OPTION] : OPTIONS).map((o) => <Option key={o.slug} o={o} on={value === o.slug} pick={onChange} />)}
    </div>
  </fieldset>
);
